import { MenuIcon } from 'lucide-react';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer.tsx';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion.tsx';
import { menuItems, useHeaderNavigation } from '@/app/layout/use-header-navigation.tsx';
import { useState } from 'react';

export function MobileDrawer() {
  const [open, setOpen] = useState(false);
  const { onMenuClick } = useHeaderNavigation();
  return (
    <Drawer open={open} onOpenChange={o => setOpen(o)} direction="left">
      <DrawerHeader className="sr-only">
        <DrawerTitle>Navigation Menu</DrawerTitle>
        <DrawerDescription>Select menu item</DrawerDescription>
      </DrawerHeader>
      <DrawerTrigger asChild>
        <MenuIcon className="md:hidden" />
      </DrawerTrigger>
      <DrawerContent className="px-4 pt-4">
        <Accordion type="multiple">
          {menuItems.map((item, index) => (
            <AccordionItem value={`item-${index}`} key={index}>
              {item.sub ? (
                <AccordionTrigger>{item.text}</AccordionTrigger>
              ) : (
                <a
                  href={item.href}
                  className="pr-10 py-4 text-sm font-medium hover:bg-gray-100 uppercase text-left flex gap-1 items-center"
                >
                  {item.text}
                </a>
              )}

              {item.sub && (
                <AccordionContent>
                  {item.sub.map((subItem, subIndex) => (
                    <a
                      key={subIndex}
                      href={subItem.href}
                      className="pl-4 pr-10 py-1.5 text-sm hover:bg-gray-100 uppercase text-left flex gap-1 items-center"
                      onClick={(e) => {
                        setOpen(false);
                        onMenuClick(e, subItem);
                      }}
                    >
                      {subItem.text}
                    </a>
                  ))}
                </AccordionContent>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </DrawerContent>
    </Drawer>
  );
}
